import { isAdminAccount } from 'helpers/permission';
import { useSelector } from 'react-redux';
import { loginSelector } from './selector';

export { ROLE_ADMIN } from 'helpers/permission';

export const LoginHook = () => {
  const token = useSelector(loginSelector.getToken);
  const account = useSelector(loginSelector.getAccount);
  const isAdmin = isAdminAccount(account);

  return { token, account, isAdmin };
};
